/* cf-gst-display.js - Click Fencing, 2026-08-15, GST-inclusive mode added 2026-08-20
 *
 * The quote review header read "Estimated Total $707.72 / DIY / Supply Only (inc. GST)".
 * On the three ALUMINIUM calculators that number is the plain sum of ex-GST Shopify
 * prices, and the store ran shop.taxesIncluded = false, so Shopify added 10% at the
 * payment step: the customer read $707.72 "inc. GST" and was asked for $778.49.
 *
 * The GLASS calculator is different - it emits its own "GST (10%)" breakdown line, so its
 * grandTotal really is GST-inclusive. Grossing that up would show GST twice. The split is
 * therefore derived from the breakdown, never assumed.
 *
 * Pete's call (2026-08-15): show ex-GST + GST + total. The big number becomes the amount
 * actually payable, with the ex-GST subtotal and the GST broken out underneath.
 *
 * GST-INCLUSIVE MODE (2026-08-20)
 * -------------------------------
 * Pete is moving the store to GST-inclusive display pricing - every Shopify price raised
 * 10% and shop.taxes_included switched on. Once that is done, quote totals already
 * include GST and grossing them up again would overstate by 10%. When
 * window.CF_TAXES_INCLUDED is true (rendered from {{ shop.taxes_included }} in
 * meta-tags.liquid) this file ALWAYS splits and never grosses up, and the breakdown /
 * editor footer is relabelled inc GST. While the setting is still off the original
 * behaviour is untouched, so this is safe to publish before or after the switch.
 *
 * Display only - quote.grandTotal is never modified. cf-real-line-items.js does the
 * matching arithmetic on the cart side. cf-gst-inclusive.js strips the glass tax line.
 *
 * Runs on /pages/quote-review only. The four calculator pages make no GST claim, so they
 * are deliberately untouched.
 *
 * Self-installing, idempotent, every path wrapped so a display fault can never block
 * checkout. Same shape as cf-quote-editor.js / cf-calc-fixes.js.
 */
(function () {
  'use strict';
  if (window.__cfGstDisplayInstalled) return;
  window.__cfGstDisplayInstalled = true;

  var GST_RATE = 0.10;
  var CALCS = ['ullc', 'blade', 'flattop', 'perfmesh'];

  /* Shopify's own setting, rendered by meta-tags.liquid. True = every price on the store,
     and therefore every calculator line, already includes GST. */
  function inclusive() { return window.CF_TAXES_INCLUDED === true; }

  /* Prices already include GST: the total IS the payable amount and the GST content is
     one eleventh of it. Never add to an inclusive total. */
  function splitInclusive(grand) {
    var gst = Math.round((grand / 11) * 100) / 100;
    return { ex: Math.round((grand - gst) * 100) / 100, gst: gst, inc: grand };
  }

  function money(n) {
    return '$' + (Math.round((Number(n) || 0) * 100) / 100).toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Which quote is on screen. Matches cf-real-line-items.js exactly, so the number shown
     here and the number charged can never come from different quotes. <calc>_active_quote
     holds the active quote NUMBER (blade stores "9"), not the quote object. */
  function candidates() {
    var out = [];
    for (var i = 0; i < CALCS.length; i++) {
      var c = CALCS[i], active = null;
      try { active = JSON.parse(localStorage.getItem(c + '_active_quote') || 'null'); } catch (e) {}
      if (active && active.breakdown && active.breakdown.length) out.push({ quote: active, isActive: true });
      var activeNum = (active !== null && typeof active !== 'object') ? Number(active) : null;
      var arr = [];
      try { arr = JSON.parse(localStorage.getItem(c + '_quotes') || '[]') || []; } catch (e) {}
      if (Object.prototype.toString.call(arr) === '[object Array]') {
        for (var j = 0; j < arr.length; j++) {
          var q = arr[j];
          if (!q || !q.breakdown || !q.breakdown.length) continue;
          out.push({ quote: q, isActive: activeNum !== null && Number(q.quoteNum) === activeNum });
        }
      }
    }
    return out;
  }

  function readQuote() {
    /* MIXED FENCE JOB (cf-job.js, 2026-09-23) — same reason as cf-real-line-items.js:
       the pill-label lookup cannot identify a job, and the split must describe the
       job total the customer is about to pay. */
    try {
      if (window.CF_JOB && window.CF_JOB.isOn()) {
        var job = window.CF_JOB.merge();
        if (job && job.breakdown && job.breakdown.length) return job;
      }
    } catch (e) {}
    /* The quote quote-review actually rendered, published by hydrate(). This is the
       authority: the pill-text match below silently stopped working when a "×" was
       appended to the pill, and its fallback can pick another calculator's quote. */
    try {
      var vq = window.__cfViewedQuote;
      if (vq && vq.breakdown && vq.breakdown.length) return vq;
    } catch (e) {}
    var list = candidates();
    if (!list.length) return null;
    var pill = document.querySelector('.qr-quote-pill.is-active');
    var label = pill ? String(pill.textContent || '').trim() : '';
    if (label) {
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].quote.quoteName || '').trim() === label) return list[i].quote;
      }
    }
    var pool = list.filter(function (r) { return r.isActive; });
    if (!pool.length) pool = list;
    pool.sort(function (a, b) {
      return (Date.parse(b.quote.generatedAt) || 0) - (Date.parse(a.quote.generatedAt) || 0);
    });
    return pool[0].quote;
  }

  /* The quote ON SCREEN. The editor's live state is preferred only when it is holding
     that same quote - it binds once at install and does not rebind on a pill switch, so
     trusting it blindly would gross up the wrong total. */
  function currentQuote() {
    var q = readQuote();
    try {
      var st = window.__cfQuoteState;
      if (st && st.quote && st.quote.grandTotal != null
          && (!q || String(st.quote.quoteName || '') === String(q.quoteName || ''))) {
        return st.quote;
      }
    } catch (e) {}
    return q;
  }

  /* Whether the quote already carries its own GST. In ex-GST mode the GLASS calculator
     emits a "GST (10%)" breakdown line, so its grandTotal is GST-INCLUSIVE while blade,
     flat top and mesh are ex-GST - so the split is derived from the breakdown rather than
     assumed. In GST-inclusive mode every total is already payable and we always split. */
  function figures() {
    var q = currentQuote();
    var grand = q && q.grandTotal != null ? Number(q.grandTotal) || 0 : 0;

    if (!grand) {
      var el = document.getElementById('qr-grand-total');
      if (el) {
        var incAttr = el.getAttribute('data-cf-inc-gst');
        var base = el.getAttribute('data-cf-ex-gst');
        if (inclusive() && incAttr) grand = Number(incAttr) || 0;
        else if (base) grand = Number(base) || 0;
        else {
          var m = String(el.textContent || '').replace(/[^0-9.]/g, '');
          grand = m ? Number(m) || 0 : 0;
        }
      }
      if (!grand) return null;
      if (inclusive()) return splitInclusive(grand);
      return { ex: grand, gst: Math.round(grand * GST_RATE * 100) / 100,
               inc: Math.round(grand * (1 + GST_RATE) * 100) / 100 };
    }

    if (inclusive()) return splitInclusive(grand);

    var tax = 0;
    if (q && q.breakdown) {
      q.breakdown.forEach(function (b) {
        if (/^tax$/i.test(String(b.category || '').trim()) || /\bgst\b/i.test(String(b.item || ''))) {
          tax += Number(b.totalPrice) || 0;
        }
      });
    }
    tax = Math.round(tax * 100) / 100;

    if (tax > 0) {
      /* Already GST-inclusive - split it out, do not add to it. */
      return { ex: Math.round((grand - tax) * 100) / 100, gst: tax, inc: grand };
    }
    var gst = Math.round(grand * GST_RATE * 100) / 100;
    return { ex: grand, gst: gst, inc: Math.round((grand + gst) * 100) / 100 };
  }

  var CSS = '.cf-gst-split{margin:2px 0 0;font-size:.82rem;color:#475569;line-height:1.45}'
    + '.cf-gst-split b{font-weight:600;color:#0f172a}'
    + '.cf-gst-split .cf-gst-sep{opacity:.45;margin:0 6px}';

  function injectCss() {
    if (document.getElementById('cf-gst-css')) return;
    var s = document.createElement('style');
    s.id = 'cf-gst-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  var applying = false;

  function apply() {
    if (applying) return;
    applying = true;
    try {
      var totalEl = document.getElementById('qr-grand-total');
      if (!totalEl) return;

      var f = figures();
      if (!f || !f.ex) return;
      var ex = f.ex, gst = f.gst, inc = f.inc;

      /* Record the bases so a later re-read never grosses up an already-grossed number.
         Recomputing from the quote each time makes this idempotent. */
      totalEl.setAttribute('data-cf-ex-gst', String(ex));
      totalEl.setAttribute('data-cf-inc-gst', String(inc));
      totalEl.textContent = money(inc);

      var split = document.getElementById('cf-gst-split');
      if (!split) {
        split = document.createElement('p');
        split.className = 'cf-gst-split';
        split.id = 'cf-gst-split';
        if (totalEl.parentNode) totalEl.parentNode.insertBefore(split, totalEl.nextSibling);
      }
      split.innerHTML = '';
      split.appendChild(document.createTextNode('Subtotal (ex GST) '));
      var b1 = document.createElement('b'); b1.textContent = money(ex); split.appendChild(b1);
      var sep = document.createElement('span'); sep.className = 'cf-gst-sep'; sep.textContent = '·'; split.appendChild(sep);
      split.appendChild(document.createTextNode('GST '));
      var b2 = document.createElement('b'); b2.textContent = money(gst); split.appendChild(b2);

      /* The old label asserted inc-GST over an ex-GST number. Strip the claim; the big
         number above is now genuinely the payable amount. */
      var label = document.getElementById('qr-pricing-label');
      if (label) {
        /* apply() re-runs on every mutation and on cf:quote-adjusted, so always rebuild
           from the label's ORIGINAL text - appending to the current text stacks the
           suffix once per run. quote-review.js also writes this label asynchronously
           after the first pass, so re-capture whenever the text is not our own output. */
        var cur = String(label.textContent || '').trim();
        var orig = label.getAttribute('data-cf-orig');
        if (cur && cur.indexOf('includes GST') < 0) {
          orig = cur;
          label.setAttribute('data-cf-orig', orig);
        }
        if (orig === null) orig = cur;
        var txt = String(orig)
          .replace(/\s*\(\s*inc\.?\s*gst\s*\)\s*/ig, '')
          .replace(/\s*inc\.?\s*gst\s*/ig, '')
          .replace(/\s*[–—-]\s*$/, '')
          .trim();
        label.textContent = (txt ? txt + ' — ' : '') + 'total shown includes GST';
      }

      /* In ex-GST mode the breakdown and editor line prices are ex-GST, so say so once
         rather than restating GST on every row. Once the store is GST-inclusive those
         same line prices include GST and the label has to flip with them. */
      var footLabel = document.querySelector('.cf-qe-foot > span');
      if (footLabel) {
        var want = inclusive() ? 'Adjusted total (inc GST)' : 'Adjusted total (ex GST)';
        if (footLabel.textContent !== want) footLabel.textContent = want;
      }
    } catch (e) {
      console.warn('[cf-gst-display] apply failed', e);
    } finally {
      applying = false;
    }
  }

  function watch() {
    try {
      var totalEl = document.getElementById('qr-grand-total');
      if (!totalEl || totalEl.__cfGstWatched) return;
      totalEl.__cfGstWatched = true;
      /* quote-review.js rewrites the total and the pricing label when the customer
         switches quote pills, and writes the label once after first paint. */
      var obs = new MutationObserver(function () {
        if (applying) return;
        setTimeout(apply, 0);
      });
      obs.observe(totalEl, { childList: true, characterData: true, subtree: true });
      var label = document.getElementById('qr-pricing-label');
      if (label) obs.observe(label, { childList: true, characterData: true, subtree: true });
    } catch (e) {}
  }

  var tries = 0;
  function tryInstall() {
    if (tries++ > 60) return;
    try {
      if (!/quote-review/.test(location.pathname)) return;
      if (!document.getElementById('qr-grand-total')) { setTimeout(tryInstall, 500); return; }
      injectCss();
      apply();
      watch();
      console.log('[cf-gst-display] installed (taxes included: ' + inclusive() + ')');
    } catch (e) {
      console.warn('[cf-gst-display] install failed', e);
      setTimeout(tryInstall, 800);
    }
  }

  document.addEventListener('cf:quote-adjusted', function () { setTimeout(apply, 0); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tryInstall);
  else tryInstall();
  setTimeout(tryInstall, 1200);
  setTimeout(tryInstall, 3000);
})();
